<template>
	<div>
	<!-- 卡片试图区域 -->
	<el-card>
	  <!-- 搜索与添加区域 -->
		<el-row :gutter="20">
			<el-col :span="8">
				<el-input
				placeholder="请输入内容"
				v-model="queryInfo.query"
				clearable
				@clear="getUserList"
				:changeValue="changeValue"
				>
				    <el-button
					slot="append"
					icon="el-icon-search"
					@click="getUserList"
					></el-button>
				  </el-input>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" @click="addDialogVisible = true">添加用户</el-button>
					</el-col>
		</el-row>
		<!-- 用户列表区域 -->
		 <el-table
		      :data="userlist"
			  border
			  stripe>
			  <el-table-column
			    type="index"
			   >
			  </el-table-column>
		      <el-table-column
		        prop="username"
		        label="用户名"
			    width="60px"
				>
		      </el-table-column>
          <el-table-column
              prop="nickname"
              label="昵称"
            width="160px"
          >
            </el-table-column>
            <el-table-column
                prop="company"
                label="所属公司"
              width="160px"
            >
              </el-table-column>
            <el-table-column
                prop="download"
                label="用户下载资源的次数/次"
              width="160px"
            >
              </el-table-column>
			   <el-table-column
			     prop="rolename"
			     label="角色"
			   	width="90px"
			   		>
			   </el-table-column>
		      <el-table-column
		        prop="email"
		        label="邮箱"
				width="150px"
				>
		      </el-table-column>
			  <el-table-column
			    prop="phone"
			    label="手机号码"
				width="100px"
				>
			  </el-table-column>
			  <el-table-column
			    prop="create_time"
			    label="创建时间"
          width="170px"
          >
          <template slot-scope="scope">
          {{scope.row.create_time | fmtdate}}
          </template>
			  </el-table-column>
			  <el-table-column
			    prop="lastlogin_time"
			    label="最后一次登录时间"
          width="170px"
          >
          <template slot-scope="scope">
          {{scope.row.lastlogin_time | fmtdate}}
          </template>
			  </el-table-column>
			  <el-table-column
			    prop="user_pic"
			    label="头像"
				width="170px"
				>
				　<template slot-scope="scope">
					<img :src="scope.row.user_pic" alt="" width="150px" height="150px"/>
					　</template>
			  </el-table-column>
			  <el-table-column
			    label="状态"
				width="53px"
				prop="statesw"
				>
				<!-- 重点！！！！如果是字符串形式返回不加冒号active-value="1" inactive-value="2"；如果是数字类型返回的加冒号:active-value="1" :inactive-value="2"-->
				<template slot-scope="scope">
					<el-switch
				      v-model="scope.row.statesw"
					  @change="userStateChanged(scope.row)"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-value="1"
					  inactive-value="2"
					 >
					</el-switch>
				</template>
			  </el-table-column>
			  <el-table-column
			    label="操作"
				width="175px"
				>
				<template slot-scope="scope">
					<el-tooltip effect="dark" content="编辑" placement="top" :enterable="false" >
					 	<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)" ></el-button>
					   </el-tooltip>
					<el-tooltip effect="dark" content="删除" placement="top" :enterable="false" >
					 	<el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.id)" ></el-button>
					   </el-tooltip>
					 <el-tooltip effect="dark" content="分配角色" placement="top" :enterable="false" >
					  	<el-button type="warning" icon="el-icon-setting" size="mini" @click="setRole(scope.$index,scope.row)" ></el-button>
					    </el-tooltip>
              <el-tooltip effect="dark" content="分配视图" placement="top" :enterable="false" >
               	<el-button style="margin-left: 0px;margin-top: 10px;" type="info" icon="el-icon-video-play" size="mini" @click="setView(scope.$index,scope.row)"></el-button>
              </el-tooltip>
					</template>
			  </el-table-column>
		    </el-table>
		<!-- 分页区域 -->
		<el-pagination
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="queryInfo.pagenum"
		      :page-sizes="[1, 2, 5, 10,`${this.total}`]"
		      :page-size="queryInfo.pagesize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
	</el-card>
	<!-- 添加用户的对话框 -->
	<el-dialog
	  title="添加用户"
	  :visible.sync="addDialogVisible"
	  width="50%"
	  @close="addDialogClosed"
    :close-on-click-modal="false"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="addFormRules"
	 ref="addFormRef"
	 :model="addForm"
	 label-width="70px">
	   <el-form-item label="用户名" prop="username">
	     <el-input v-model="addForm.username"></el-input>
	   </el-form-item>
	   <el-form-item label="密码" prop="password">
	     <el-input v-model="addForm.password" type="password"  show-password></el-input>
	   </el-form-item>
	   </el-form-item>
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="addDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="addUser">确 定</el-button>
	  </span>
	</el-dialog>
	<!-- 修改用户的对话框 -->
	<el-dialog
	  title="修改用户"
	  :visible.sync="editDialogVisible"
	  width="50%"
	  @close="editDialogClosed"
    :close-on-click-modal="false"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="editFormRules"
	 ref="editFormRef"
	 :model="editForm"
	 label-width="70px">
	   <el-form-item label="用户名" prop="username">
	     <el-input v-model="editForm.username" disabled></el-input>
	   </el-form-item>
	  <el-form-item label="密码" prop="password">
	    <el-input v-model="editForm.password" type="password"  show-password></el-input>
	  </el-form-item>
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="editDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="editUserInfo">确 定</el-button>
	  </span>
	</el-dialog>
	<!-- 分配角色对话框 -->
	<el-dialog
	  title="分配角色"
	  :visible.sync="setRoleDialogVisible"
	  width="50%"
	  @close="setRoleDialogClosed"
	  >
	 <div style="padding: 15px;">
		<p>当前的用户:&nbsp &nbsp {{userInfoS.username}}</p>
		<p>当前的角色:&nbsp &nbsp {{userInfoS.rolename}}</p>
		<p>分配新角色:
		<el-select v-model="selectedRoleId" placeholder="请选择" >
		    <el-option
		      v-for="item in roleslist"
		      :key="item.rid"
		      :label="item.rolename"
		      :value="item.rid">
		    </el-option>
		  </el-select>
		</p>
	 </div>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="setRoleDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="saveRoleInfo">确 定</el-button>
	  </span>
	</el-dialog>
  <!-- 分配视图对话框 -->
  <el-dialog
    title="分配视图"
    :visible.sync="setViewDialogVisible"
    width="50%"
    @close="setViewDialogClosed"
    >
    <el-alert
        title="全局视图>部门视图>个人视图,所以一个业务模块选择一项视图即可!"
        type="warning"
        show-icon
    		  :closable="false"
    		  style="margin-bottom: 15px;"
    		  >
      </el-alert>
   <div style="padding: 5px;" class="abow_dialog">
  	 <p>分配视图:
  	   <el-select v-model="value1" multiple placeholder="请选择" @change="jgTreeChange">
  	     <el-option
  	       v-for="item in options"
  	       :key="item.value"
  	       :label="item.label"
  	       :value="item.value">
  	     </el-option>
  	   </el-select>
  	   </p>

   </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="setViewDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveViewInfo">确 定</el-button>
    </span>
  </el-dialog>




		</div>
</template>

<script>
	export default{
		data(){
			return{
				//获取用户列表的参数对象
				queryInfo:{
					query:'',
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:5
				},
				userlist:[],
				total:0,
				//控制添加用户对话框的显示与隐藏
				addDialogVisible:false,
				//控制修改用户对话框的显示与隐藏
				editDialogVisible:false,
				//添加用户的表单数据
				addForm:{
					username:'',
					password:'',
				},
                //添加表单的验证规则对象
				addFormRules:{
					username:[
						{required:true,message:'请输入用户名',trigger:'blur'},
						{min:1,max:5,message:'用户名的长度在1~5字符之间',trigger:'blur'}
					],
					password:[
						{required:true,message:'请输入密码',trigger:'blur'},
						{min:6,max:15,message:'密码的长度在6~15字符之间',trigger:'blur'}
					],
				},
				//查询到的用户信息对象
				editForm:{},
				//修改表单的验证规则对象
				editFormRules:{
					password:[
						{required:true,message:'请输入密码',trigger:'blur'},
						{min:6,max:15,message:'密码的长度在6~15字符之间',trigger:'blur'}
					],
				},
				//控制分配角色对话框的显示与隐藏
				setRoleDialogVisible:false,
				//需要被分配角色的用户信息
				userInfoS:{},
				//所有角色的数据列表
				roleslist:[],
				//已选中的角色Id值数组
				selectedRoleId:'',
			  //----------------------------------------
        //视图
        setViewDialogVisible:false,
          options: [
        					{
        					  value: 1,
        					  label: '供应链产能全局视图'
        					},{
        					  value: 3,
        					  label: '供应链产能个人视图'
        					},
                  {
                    value: 6,
                    label: '订单数据全局视图'
                  },{
                    value: 7,
                    label: '订单数据个人视图'
                  }, {
                    value: 8,
                    label: '供应链实际产能全局视图'
                  },{
                    value: 9,
                    label: '供应链实际产能个人视图'
                  },
                  {
                    value: 4,
                    label: '产能图形全局视图'
                  },{
                    value: 5,
                    label: '产能图形个人视图'
                  }
        					  ],
                value1: [],
        					  viewId:'',
			}
		},
		created(){
			this.getUserList()
		},
		computed:{
			//监听输入框是否有值，边打字边搜索
			changeValue(e){
				//点击后面几页，不显示数据、筛选指定跳到第一页。可以解决bug
				if(this.queryInfo.query){
					return this.queryInfo.pagenum = 1
					}
			}
		},
		methods:{
			async getUserList(){
				const {data:res} = await this.$http.getuserList({params:this.queryInfo})
				if (res.status !==0){
	             return this.$message.error('获取用户列表失败!')
				}
				this.userlist = res.data
				this.total = res.total
				console.log(this.userlist)
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize){
				console.log(newSize)
				this.queryInfo.pagesize = newSize
				this.getUserList()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage){
				console.log(newPage)
				this.queryInfo.pagenum = newPage
				this.getUserList()
			},
			// //监听 switch 开关状态的改变
			async userStateChanged(userinfo){
				const {data:res} = await this.$http.updateState({data:{statesw:userinfo.statesw,id:userinfo.id}})
				if (res.status !==0){
					return this.$message.error('更新用户状态失败!')
					  	userinfo.statesw = !userinfo.statesw
				}
				this.$message.success('更新用户状态成功!')
			},
			//点击按钮，添加新用户
			addUser(){
				this.$refs.addFormRef.validate(async valid =>{
					if (valid){ //如果表单验证合格
						const { data: res } = await this.$http.reqRegister(this.addForm)
						if (res.status == 2){
						return this.$message.error('用户名被占用，请更换用户名！')
						}else if(res.status == 1){
						return this.$message.error('用户名只允许包含数字和字母！')
						}else if(res.status == 0){
							this.$message.success('添加用户成功')
							//隐藏添加用户的对话框
							this.addDialogVisible = false
							//重新获取用户列表数据
							this.getUserList()
						}
					}else{//表单验证不合格，阻止默认行为（因为按钮有默认提交行为）
						return false
					}

				})
			},
			//监听添加用户对话框的关闭
			addDialogClosed(){
				this.$refs.addFormRef.resetFields()
			},
			//展示编辑用户的对话框
			async showEditDialog(id){
				const {data:res} = await this.$http.byIduser(id)
				if (res.status !==0){
					return this.$message.error('查询用户信息失败!')
				}
				this.editForm = res.data
				console.log(this.editForm)
				this.editDialogVisible = true
			},
			//监听修改用户对话框的关闭
		//修改用户信息并提交
		editUserInfo(){
			this.$refs.editFormRef.validate(async valid =>{
				if (valid){
					const {data:res} = await this.$http.editUser({data:{
						id:this.editForm.id,
						password:this.editForm.password
					}})
						if (res.status !==0){
							return this.$message.error('修改用户失败!')
						}
						this.$message.success('修改用户成功!')
							//this.$store.dispatch('updateUserInfo')
						//隐藏修改用户的对话框
						this.editDialogVisible = false
						//重新获取用户列表数据

						this.getUserList()

				}else{
					return false
				}

			})
		},
		editDialogClosed(){
			this.$refs.editFormRef.resetFields()
		},
		//根据Id删除对应的用户信息
		async removeUserById(id){
			//弹框询问用户是否删除数据
			        const confirmResult = await this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).catch(err => err)
					//如果用户确认删除，则返回值为字符串 confirm
					console.log(confirmResult)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delUser(id)
					if (res.status !==0){
						return this.$message.error('删除用户失败!')
					}
					this.$message.success('删除用户成功!')
					this.getUserList()
		},
		//展示分配角色的对话框
		async setRole(index,userInfo){
			//this.userInfoS=userInfo==scope.row
			this.userInfoS = userInfo
			console.log(this.userInfoS)
			// 在展示对话框之前，获取所有角色列表
				const {data:res} = await this.$http.getrolesList()
				if (res.status !==0){
					return this.$message.error('获取角色列表失败!')
				}
				this.roleslist = res.data
				console.log(this.roleslist)
			//默认选中的，给赋值
			//rid角色id，rolename角色名称
			//默认选中值是从用户里面的rid拿
			this.selectedRoleId = Number(this.userInfoS.rid)
			console.log(this.selectedRoleId)
			this.setRoleDialogVisible = true
		},
		//点击按钮，分配角色
		async saveRoleInfo(){
			console.log(this.userInfoS.id)
			if (!this.selectedRoleId){
				return this.$message.error('请选择要分配的角色!')
			}
			const {data:res} = await this.$http.saveroles({data:{
				//这里的rid是用户的rid
				rid:this.selectedRoleId,
				id:this.userInfoS.id
			}}
			)
			if (res.status !==0){
			 return this.$message.error('更新角色失败!')
			}
			this.$message.success('更新角色成功!')
			this.setRoleDialogVisible = false
			this.getUserList()
		},
		//监听分配角色对话框的关闭事件
		setRoleDialogClosed(){
			this.selectedRoleId = ''
			this.userInfoS = {}
		},
    //--------------------------------视图
    //分配视图
    setView(index,view){
    	console.log(view.id,view.view_st)
    	this.viewId = view.id
    	//split字符串变成数组,数组如果有引号，需要纯数字则map(Number)
    	this.value1 =view.view_st == null ? []:view.view_st.split(",").map(Number)
    	this.setViewDialogVisible = true
    },
    //监听视图的选值
    jgTreeChange(val){
    	console.log(val)
    },
    //分配视图
    async saveViewInfo(){
    	//去除数组选值莫名多出来的0
    	let arry = this.value1.filter((el) => {
    	    return el !== 0
    	})
    	let idStr = arry.join(",")
    	console.log(idStr)
    	 const {data:res} = await this.$http.saveView(
    	 {data:{
    	 	id:this.viewId,
    	 	view_st:idStr
    	 }}
    	 )
    	 if (res.status !==0){
    	  return this.$message.error('分配视图失败！')
    	 }
    	 this.$message.success('分配视图成功!')
    	 this.setViewDialogVisible = false
    	 this.getUserList()

    },
    setViewDialogClosed(){
    	this.value1=''
    }










		}
	}
</script>
<style lang="less" scoped>
.abow_dialog{
	height: 350px;
}

</style>
